module.exports = __webpack_public_path__ + "static/media/s43.2d9b92bb.jpg";